<template>
  <div>
    <img :src="img" style="height: 207.87px; width: 325.039px " />
    <img :src="profileimg" style="height: 106px; width: 84px; margin-left:-307px " />
    <p style="height: 10px; width: 250px; margin-left: 131px; margin-top: -126px; font-size: 12px; color: black; font-family:Nexa; font-weight:bold">{{data.Name}}</p>
    <p style="height: 10px; width: 250px; margin-left: 131px; margin-top: 15px; font-size: 9px; color: black; font-family:Nexa; font-weight:bold">Roll No:</p>
    <p style="height: 10px; width: 150px; margin-left: 194px; margin-top: -19px; font-size: 9px; color: black; font-family: Nexa; font-weight: bold ">{{data.RollNo}}</p>
    <p style="height: 10px; width: 250px; margin-left: 131px; margin-top: -3px; font-size: 9px; color: black; font-family: Nexa; font-weight: bold ">Program:</p>
    <p style="height: 10px; width: 150px; margin-left: 194px; margin-top: -19px; font-size: 9px; color: black; font-family: Nexa; font-weight: bold ">{{data.Program}}</p>
    <p style="height: 10px; width: 250px; margin-left: 131px; margin-top: -3px; font-size: 9px; color: black; font-family: Nexa; font-weight: bold">Session:</p>
    <p style="height: 10px; width: 150px; margin-left: 194px; margin-top: -19px; font-size: 9px; color: black; font-family: Nexa; font-weight: bold ">{{data.Session}}</p>
    <p style="height: 10px; width: 250px; margin-left: 131px; margin-top: -3px; font-size: 9px; color: black; font-family: Nexa; font-weight: bold">Department:</p>
    <p style="height: 10px; width: 150px; margin-left: 194px; margin-top: -19px; font-size: 9px; color: black; font-family: Nexa; font-weight: bold">{{data.Department}}</p>
  </div>
</template>
<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        data: {
          Name: '',
          RollNo: '',
          Program: '',
          Session: '',
          Department: '',
        },
        img: '',
        profileimg: '',
      }
    },

    created: function () {
    },

    mounted: function () {
      this.loadCardFrontData();
    },

    updated: function () {

    },

    methods: {
      loadCardFrontData() {
        var vm = this;
        axios.post('/api/StudentCardPrintingApi/loadCardFrontData')
          .then(function (response) {
            vm.data = response.data.lst;
            vm.img = response.data.img;
            vm.profileimg = response.data.profileimg;
            console.log(response);
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    }
  })</script>



// WEBPACK FOOTER //
// src/components/cardprinting/printcardfront.vue